import React from 'react';
import { Dialog, DialogContent } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import Button from 'modules/views/shared/Button';
import { IContact } from 'modules/state-mgmt/workerData';
import { STYLE } from 'constants/style';
import { ReactComponent as EmailVerificationSentSvg } from 'assets/images/EmailVerificationSent.svg';

interface IVerificationSentModalProps {
  isVisible: boolean;
  onClose: () => void;
  onVerifyNow: () => void;
  contact: IContact | null;
}

export const VerificationSentModal: React.FC<IVerificationSentModalProps> = ({ isVisible, onClose, onVerifyNow, contact }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const sentToLabel = contact?.contactType === 0
    ? t('myProfile.loginInformation.verificationSentModal.sentToEmail')
    : t('myProfile.loginInformation.verificationSentModal.sentToPhone');

  return (
    <Dialog
      disableScrollLock
      open={isVisible}
      onClose={onClose}
      className={classes.dialog}
      data-testid="verification-sent-modal"
    >
      <DialogContent className={classes.content}>
        <EmailVerificationSentSvg className={classes.illustration} />
        <p className={classes.title}>
          {t('myProfile.loginInformation.verificationSentModal.titlePart1')}<br />{sentToLabel}
        </p>
        <p className={classes.description}>
          {t('myProfile.loginInformation.verificationSentModal.description')}{' '}
          <span className={classes.contactValue}>{contact?.contactValue}</span>
        </p>
        <Button
          label={t('myProfile.loginInformation.verificationSentModal.verifyNow')}
          styleClass={classes.button}
          testId="verification-sent-verify-now-button"
          onClick={onVerifyNow}
        />
      </DialogContent>
    </Dialog>
  );
};

const useStyles = makeStyles(() => ({
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: '16px',
      width: '100%',
      maxWidth: '560px',
      margin: '20px',
      padding: '18px 40px 40px',
      boxShadow: '0px 8px 32px rgba(0, 0, 0, 0.12)',
    },
    '& .MuiModal-backdrop': {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
  },
  content: {
    padding: '0 !important',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  illustration: {
    width: '240px',
    height: '240px',
    marginBottom: '24px',
  },
  title: {
    fontFamily: STYLE.FONT.PRIMARY_FONT,
    fontSize: '24px',
    fontWeight: 500,
    lineHeight: '28px',
    color: STYLE.COLOR.TEXT1,
    margin: '0 0 12px',
  },
  description: {
    fontFamily: STYLE.FONT.PRIMARY_FONT,
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '26px',
    color: STYLE.COLOR.TEXT1,
    margin: '0 0 28px',
  },
  contactValue: {
    color: STYLE.COLOR.ACCENT_PRIMARY,
    fontWeight: 500,
  },
  button: {
    minWidth: '200px !important',
    borderRadius: '30px !important',
    padding: '12px 40px !important',
    height: 'auto !important',
  },
}));
